if (window.location.href.indexOf('127.0.0.1') !== -1) {
  throw new Error('Use localhost instead of 127.0.0.1 for development!')
}

export const ExpressServerRoot =
  window.location.href.indexOf('localhost') !== -1 ? `http://localhost:5000` : ''

export const Timezones = [
  { value: 'America/Los_Angeles', label: 'Pacific Time / Los Angeles (UTC-8)' },
  { value: 'America/Denver', label: 'Mountain Time / Denver (UTC-7)' },
  { value: 'America/Chicago', label: 'Central Time / Chicago (UTC-6)' },
  { value: 'America/New_York', label: 'Eastern Time / New York (UTC-5)' },
]
